<div class="se-app__header" lang="en">
  <span *ngIf="organization.id">
    <se-org-avatar
      [se-data-identity]="organization.name"
      [se-data-img-url]="organization.logo.is_default ? null : organization.logo.url"
      se-data-size="300"
    >
    </se-org-avatar>
  </span>
  <div class="se-app__headings">
    <h2 class="se-app__title" *ngIf="title">{{ title }}</h2>
    <h3 class="se-app__subtitle">{{ subtitle }}</h3>
  </div>
  
  <a class="pl-link" target="_blank" [href]="profileUrl" *ngIf="persona">
    <se-persona-avatar
      [se-data-identity]="persona.fullName"
      [se-data-img-url]="persona.profileImage('crop') || ''"
      se-data-size="300"
    >
    </se-persona-avatar>
  </a>
</div>
